import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import About from "./components/About";
import Header from "./components/Header";
import Banner from "./components/Banner";
import Team from "./components/Team";
// import Testimonials from "./components/Testimonials";
import Footer from "./components/Footer";
import ServiceDetail from "./components/ServiceDetail";
import ServicesPage from "./components/ServicesPage";
import BackToTop from "./components/BackToTop";
import Preloader from "./components/Preloader";

function HomePage() {
  return (
    <>
      <Header />
      <Banner />
      <About />
      <Team />
      {/* <Testimonials /> */}
      <Footer />
      <BackToTop />
      {/* <div className="h-[2000px]"></div> */}
    </>
  );
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/services" element={<ServicesPage />} />
      <Route path="/services/:slug" element={<ServiceDetail />} />
    </Routes>
  );
}

export default function App() {
  const location = useLocation();
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    // show loader briefly on every route change
    setLoading(true);
    const t = setTimeout(() => setLoading(false), 750);
    return () => clearTimeout(t);
  }, [location.pathname]);

  return (
    <>
      {loading && <Preloader />}
      <AppRoutes />
    </>
  );
}
